import {
  Component,
  Input,
  ElementRef,
  HostListener,
  AfterViewInit,
} from '@angular/core';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.css'],
})
export class MenuItemComponent implements AfterViewInit {
  @Input() menu!: any;
  @Input() level: number = 0;

  showSubmenu = false;
  submenuTop = 0;
  submenuLeft = 0;

  constructor(private elRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.calculateSubmenuPosition();
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    this.showSubmenu = true;
    if (window.innerWidth > 850) {
      this.calculateSubmenuPosition();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (window.innerWidth > 850) {
      this.showSubmenu = false;
    }
  }

  calculateSubmenuPosition() {
    const rect = this.elRef.nativeElement.getBoundingClientRect();
    const screenWidth = window.innerWidth;

    if (screenWidth <= 850) {
      this.submenuTop = 0;
      this.submenuLeft = 0;
    } else {
      this.submenuTop = rect.top;

      if (this.level === 0) {
        this.submenuLeft = 240;
      } else {
        this.submenuLeft = rect.right;
      }
    }
  }

  // getMenuIcon(linkto: string): string[] {
  //   switch (linkto) {
  //     case 'seperator':
  //       return ['bi-file-earmark-text'];
  //     case 'report':
  //       return ['fadeIn', 'animated', 'bi', 'bi-clipboard2-data'];
  //     case 'url':
  //       return ['bi', 'bi-link-45deg'];
  //     case 'form':
  //       return ['fadeIn', 'animated', 'bi', 'bi-postcard'];
  //     default:
  //       return ['bi', 'bi-file'];
  //   }
  // }

  getMenuIcon(linkto: string): string[] {
    switch (linkto) {
      case 'seperator':
        return ['bx', 'bx-shape-square'];
      case 'report':
        return ['bx', 'bx-bar-chart-alt-2'];
      case 'url':
        return ['bx', 'bx-link-alt'];
      case 'form':
        return ['bx', 'bx-folder'];
      default:
        return ['bx', 'bx-file'];
    }
  }

  getMenuLinkTo(menu: any): string[] {
    switch (menu.linkto) {
      case 'form':
        return ['uiformlist', menu.formId];
      case 'report':
        return ['reportslist', menu.reportsId];
      case 'url':
        return [menu.url];
      default:
        return ['#'];
    }
  }
}
